import { IsEmailVerificationCodeValidData } from "generated/unauth-account";

export const buildVerifyMfaPayload = (
  state: IsEmailVerificationCodeValidData["mfaState"],
): string | null => {
  // MFA needs to already be setup in order for us to be able to verify it.
  if (state.__typename !== "SetupMfaState") return null;

  const totpMethod = state.supportedMethods.find(
    (it): it is Extract<typeof it, { __typename: "TotpMfaMethod" }> =>
      it.__typename === "TotpMfaMethod" && it.isSetup,
  );

  return totpMethod ? "totp" : null;
};
